import React, { useState } from "react";
import { Loader2 } from "lucide-react";

const ForgotPassword = ({ showForgotPass, setShowForgotPass }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const closeModal = () => {
    setShowForgotPass(false);
    setEmail("");
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      alert("Please enter your email");
      return;
    }
    
    setLoading(true);
    setMessage("");

    try {
      const host = process.env.REACT_APP_API_URL || "http://localhost:5000";
      const response = await fetch(`${host}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      
      if (response.ok) {
        setMessage(data.message || "Reset link sent to your email.");
      } else {
        setMessage(data.error || "Something went wrong.");
      }
    } catch (error) {
      console.error(error);
      setMessage("Failed to connect to the server.");
    } finally {
      setLoading(false);
    }
  };

  if (!showForgotPass) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center">
      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm animate-fadeIn"
        onClick={closeModal}
      ></div>

      {/* MODAL BOX */}
      <div className="relative w-[95%] md:w-[400px] bg-[#222] text-white rounded-2xl border border-white/10 p-6 shadow-xl animate-scaleIn">
        {/* CLOSE BUTTON */}
        <button
          onClick={closeModal}
          className="absolute top-3 right-4 text-gray-300 text-2xl hover:text-white transition"
        >
          ×
        </button>

        <h1 className="text-xl font-semibold mb-2">Reset Password</h1>
        <p className="text-sm text-gray-400 mb-6">Enter your email address to receive a reset link.</p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="text-sm font-semibold text-gray-300">Email Address</label>
            <input
              type="email"
              className="w-full bg-[#111] mt-1 p-3 rounded border border-white/10 text-white outline-none focus:ring-2 focus:ring-yellow-400 transition"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-yellow-400 text-black p-3 rounded font-bold hover:bg-yellow-300 transition flex justify-center items-center mt-2 ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : "Send Reset Link"}
          </button>
          
          {message && (
            <p className="text-green-400 text-sm mt-2 text-center">{message}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
